const uploadSubmitErrorModalSupport = {
  label: 'Wait for all the file to go up'
};

export default uploadSubmitErrorModalSupport;
